import { writable } from 'svelte/store';
import { loadSurveyList } from '../api/survey-search.api';
export default class SurveySearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._list = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this.loadSearchResults();
    }
    loadSearchResults() {
        this._processing.set(true);
        const filterParams = {
            published: JSON.stringify(this.dataProvider.published),
            showSiteUrl: this.dataProvider.showSiteUrl,
        };
        loadSurveyList(filterParams)
            .then((response) => {
            this._list.set(response.results);
            this._total.set(response.total);
            this._error.set(false);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get listSubs() {
        return this._list;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
}
